import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
  className?: string;
}

export default function Breadcrumbs({ items, className = "" }: BreadcrumbsProps) {
  const fullCrumbs: Crumb[] = [{ label: "首页", path: "/" }, ...items];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: fullCrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: crumb.label,
      item: crumb.path ? `${siteInfo.url}${crumb.path === "/" ? "/" : crumb.path}` : undefined,
    })),
  };

  return (
    <nav aria-label="面包屑导航" className={className}>
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500 md:text-sm">
        {fullCrumbs.map((crumb, index) => {
          const isLast = index === fullCrumbs.length - 1;
          return (
            <li key={`${crumb.label}-${index}`} className="flex items-center gap-2">
              {crumb.path && !isLast ? (
                <Link
                  to={crumb.path}
                  className="transition-colors hover:text-primary-600"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-700" : ""} aria-current={isLast ? "page" : undefined}>
                  {crumb.label}
                </span>
              )}
              {!isLast ? (
                <span className="flex h-3 w-3 items-center justify-center text-foreground-400" aria-hidden="true">
                  <i className="ri-arrow-right-s-line text-sm" />
                </span>
              ) : null}
            </li>
          );
        })}
      </ol>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </nav>
  );
}